import React from 'react';

/**
 * La domanda del cestino delle visite (migration 291, risposta 2 di Alex del
 * 2 ottobre 2026): dalla visita sono usciti prodotti dal magazzino, sono
 * stati usati? Niente reso automatico: risponde chi mette la visita nel
 * cestino.
 *  - «No»: tornano in magazzino, con un reso riferito alla riga;
 *  - «Sì»: restano scaricati, la somministrazione resta registrata - segnata
 *    «visita nel cestino» anche nella ricerca per lotto, perche' un richiamo
 *    di un lotto non deve perdere una somministrazione avvenuta - e
 *    l'amministrazione riceve un compito.
 * «Annulla» non cancella niente.
 *
 * IL «RIASSEGNA» (risposte 6 e 7 di Alex del 3/10/2026, migration 292).
 * Risponde chi mette la visita nel cestino, e nel dubbio annulla e chiede al
 * medico. «Sì» quando il trattamento c'e' stato: se e' stato fatto a un
 * ALTRO paziente, la procedura si registra su di lui e l'amministrazione,
 * dal compito, sposta la somministrazione col suo lotto («Riassegna»): lo
 * scarico della nuova registrazione torna in magazzino, e la merce esce una
 * volta sola. «No» quando non sono stati usati, o quando lo stesso
 * trattamento e' registrato su un'altra visita di QUESTO paziente: quella ha
 * gia' i suoi prodotti, e il «Riassegna» non sposta sullo stesso paziente.
 *
 * L'elenco arriva dal server (visita_prodotti_scaricati nel database): la
 * schermata non lo ricostruisce.
 */
const quanti = (q) => Number(q).toLocaleString('it-IT', { maximumFractionDigits: 4 });

const DomandaProdottiUsati = ({ prodotti, inCorso, onRisposta, onAnnulla }) => (
    <div className="modal-overlay" onClick={inCorso ? undefined : onAnnulla}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}
             role="dialog" aria-modal="true" aria-labelledby="domanda-prodotti-titolo">
            <div className="modal-header">
                <h2 id="domanda-prodotti-titolo">I prodotti sono stati usati?</h2>
                <button className="btn-close" onClick={onAnnulla} disabled={inCorso} aria-label="Chiudi">✕</button>
            </div>
            <div className="form-group">
                <p>Per questa visita sono usciti dal magazzino:</p>
                <ul>
                    {(prodotti || []).map((p, i) => (
                        <li key={i}>{p.prodotto} — lotto {p.codice_lotto || '—'}: {quanti(p.quantita)}</li>
                    ))}
                </ul>
                <small className="consenso-nota">
                    «Sì» se il trattamento c'è stato: restano scaricati e l'amministrazione riceve un
                    compito. Se è stato fatto a un altro paziente, registra la procedura su di lui:
                    l'amministrazione, dal compito, ci sposta la somministrazione col suo lotto, e i
                    prodotti escono una volta sola. «No» se non sono stati usati, <strong>o se lo stesso
                    trattamento è registrato su un'altra visita di questo paziente</strong>: tornano in
                    magazzino. Se non lo sai, annulla e chiedi al medico che ha eseguito la visita.
                </small>
            </div>
            <div className="modal-footer">
                <button type="button" className="btn-secondary" onClick={onAnnulla} disabled={inCorso}>Annulla</button>
                <button type="button" className="btn-secondary" onClick={() => onRisposta(false)} disabled={inCorso}>
                    No, tornano in magazzino
                </button>
                <button type="button" className="btn-primary" onClick={() => onRisposta(true)} disabled={inCorso}>
                    Sì, sono stati usati
                </button>
            </div>
        </div>
    </div>
);

export default DomandaProdottiUsati;
